<template>
  <div class="container">
    <div class="record-list">
      <div class="item" v-for="(item,index) in recordList" :key="index">
        <div class="flex-row-bc">
          <div class="name">{{`${item.promotion_name}-${item.coupon_num}张${item.coupon_amount}元优惠券`}}</div>
          <div class="price" :class="item.order_status === 0?'c-FF4A61':''">¥<span>{{item.payment_amount}}</span></div>
        </div>
        <div class="flex-row-bc" style="padding-top: .2rem" v-if="item.order_status === 0">
          <div></div>
          <div class="c-FF4A61">待支付</div>
        </div>
        <div class="flex-row-bc" style="padding-top: .2rem" v-if="item.order_status === 0">
          <div>{{item.order_date}}自动取消</div>
          <div class="btns">
            <div class="btn" @click="cancelOrder(item.order_id)">取消订单</div>
            <div class="btn btn-pay" @click="toPay(item)">继续支付</div>
          </div>
        </div>
        <div class="flex-row-bc" style="padding-top: .2rem" v-else>
          <div>{{item.created_at}}</div>
          <div class="c-999">{{item.order_statusTips}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { actions } from "../store/actions";
export default {
  name: "CouponPackageRecord",
  data() {
    return {
      recordList: []
    };
  },
  created() {
    this.getRecordList();
  },
  methods: {
    getRecordList() {
      let _this = this;
      let params = {
        page: 1,
        page_size: 1000
      };
      actions.postPackagePurchaseRecord(_this, params, (data) => {
        if(data && data.list && data.list.length > 0){
          for(let v of data.list){
            let order_status = v.order_status,
              order_status_str = '';
            switch(order_status){
              case 0:
                order_status_str = '待支付';
                break;
              case 1:
                order_status_str = '已支付';  
                break;
              case 2:
                order_status_str = '已取消';  
                break;
              case 3:
                order_status_str = '已发放';  
                break;
            }
            v.order_status_str = order_status_str;
            // if(v.order_status === 0){
            //   v.minutes = '00';
            //   v.seconds = '00';
            //   if(v.order_date && new Date().getTime() < new Date(v.order_date).getTime()){
            //     this.countdowns(v);
            //   }
            // }
          }
          _this.recordList = data.list;
        }else{
          _this.$toast('您还没有购买过券包哦')
        }
      });
    },
    countdowns(item) {
      let _this = this
      let now = new Date().getTime()
      let date = new Date(item.order_date).getTime()
      let SysSecond = parseFloat(date-now) / 1000
      _this.timer = window.setInterval(function () {
        if (SysSecond > 0) {
          SysSecond = SysSecond - 1
          let minutes = Math.floor((SysSecond / 60) % 60)      // 计算分
          let seconds = Math.floor(SysSecond % 60)             // 计算秒
          if (seconds < 10) {
            item.seconds = '0' + seconds
          } else {
            item.seconds = seconds
          }
          if (minutes < 10) {
            item.minutes = '0' + minutes
          } else {
            item.minutes = minutes
          }
        } else {
          window.clearInterval(_this.timer)
          item.minutes = '00'
          item.seconds = '00'
          _this.getRecordList()
          // _this.$messagebox.alert('支付超时', '')
        }
      }, 1000)
    },
    toPay(item) {
      window.localStorage.setItem("order-type", 8);
      window.localStorage.setItem("orderCode", item.order_id);
      this.$router.push({ name: "Payment" });
    },
    // 取消订单
    cancelOrder(id) {
      this.$messagebox.confirm('确定取消订单吗?', '').then(action => {
        var _this = this
        var params = {
          order_id: id
        }
        actions.postCancelOrder(_this, params, function (data) {
          _this.$toast('取消成功')
          _this.getRecordList()
        })
      }).catch(() => {

      })
    },
  },
};
</script>
<style scoped>
.c-FF4A61{
  color: #FF4A61 !important;
}
.c-999{
  color: #999;
}
.container {
  padding: 0.24rem;
}
.container .record-list .item{
  padding: .24rem;
  background: #FFFFFF;
  border-radius: .16rem;
  font-size: .24rem;
  color: #666;
  margin-bottom: .2rem;
}
.container .record-list .item .name{
  font-weight: bold;
  font-size: .32rem;
  color: #333;
}
.container .record-list .item .price{
  font-weight: bold;
  font-size: .2rem;
  color: #333;
}
.container .record-list .item .price span{
  font-size: .4rem;
}
.container .record-list .item .btns{
  display: flex;
}
.container .record-list .item .btns .btn{
  padding: .12rem .22rem;
  border: 1px solid #CCCCCC;
  border-radius: .28rem;
  font-size: .24rem;
  margin-left: .16rem;
  color: #666;
}
.container .record-list .item .btns .btn.btn-pay{
  background: linear-gradient(135deg, #FFEC00 0%, #FED400 100%);
  border: none;
  color: #333;
}
</style>


// WEBPACK FOOTER //
// CouponPackageRecord.vue?6857537e